// extracted by mini-css-extract-plugin
export default {"productcard":"yy","productimage":"zy","username":"Ay","multiBagName":"By","productinfo":"Cy","productinfoinner":"Ey","productname":"Fy","productsubheader":"Gy","productdescription":"Hy","productnumbers":"Iy","productnumberstitle":"Jy","productnumbersitem":"Ky","number":"Ly","numbertext":"My","tabs":"Ny","benefitsblock":"Oy","benefit":"Py","benefitname":"Qy","benefitdescription":"Ry","ingredientsblock":"Sy","tipsblock":"Ty","mobileonly":"Uy"};
    if(module.hot) {
      // 1711717533315
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  